export const Orientations={
    portrait: "CARD_ORIENTATION_PORTRAIT",
    landscape:"CARD_ORIENTATION_LANDSCAPE",
    dual:"CARD_ORIENTATION_DUAL"
}

export const available_send_dates = [
    // {
    //     "send_date":"Nov-06-2026",
    //     "value":"2026-11-06",
    //     "drop_date":"Nov-02-2026"
    // },
    {
        "send_date":"Nov-18-2026",
        "value":"2026-11-18",
        "drop_date":"Nov-12-2026"
    },
    {
        "send_date":"Dec-11-2026",
        "value":"2026-12-11",
        "drop_date":"Dec-07-2026"
    },
    {
        "send_date":"Dec-21-2026",
        "value":"2026-12-21",
        "drop_date":"Dec-15-2026"
    },
    {
        "send_date":"Jan-04-2027",
        "value":"2027-01-04",
        "drop_date":"Dec-28-2026"
    }
]